<footer class="bg-[#15261C] text-white py-12 px-6 md:px-20 text-sm">
  <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-8">
    <!-- Logo -->
    <div>
      <img class="max-w-32" src="/images/logo.svg" alt="Wellext" />
    </div>

    <!-- Deine wellbase -->
    <div>
      <h3 class="font-semibold mb-2">Deine <span class="italic">wellbase</span></h3>
      <ul class="space-y-1">
        <li><a href="https://www.wellext.de/angebote/whirlpool-frankfurt">Whirlpool</a></li>
        <li><a href="https://www.wellext.de/angebote/finnische-sauna-frankfurt">Sauna</a></li>
        <li><a href="https://www.wellext.de/angebote/erlebnisdusche-frankfurt">Erlebnisdusche</a></li>
        <li><a href="https://www.wellext.de/angebote/massagesessel-frankfurt">Massagesessel</a></li>
        <li><a href="https://www.wellext.de/angebote/chillout-lounge-frankfurt">Lounge & Entertainment</a></li>
        <li><a href="https://www.wellext.de/angebote/xbox-frankfurt">Xbox Series X</a></li>
        <li><a href="https://www.wellext.de/angebote/getranke-speisen">Speisen & Getränke</a></li>
      </ul>
    </div>

    <!-- Unternehmen -->
    <div>
      <h3 class="font-semibold mb-2">Unternehmen</h3>
      <ul class="space-y-1">
        <li><a href="https://www.wellext.de/about">Über Uns</a></li>
        <li><a href="https://www.wellext.de/faq">FAQ</a></li>
      </ul>
    </div>

    <!-- Shop -->
    <div>
      <h3 class="font-semibold mb-2">Shop</h3>
      <ul class="space-y-1">
        <li><a href="https://www.wellext.de/gutscheine">Gutscheine</a></li>
        <li><a routerLink="/">wellbase buchen</a></li>
      </ul>
    </div>

    <!-- Address -->
    <div>
      <h3 class="font-semibold mb-2">Mitten in Frankfurt</h3>
      <p>Goldsteinstraße 132-134,<br />Frankfurt am Main</p>
    </div>
  </div>

  <!-- Bottom Bar -->
  <div
    class="max-w-7xl mx-auto mt-10 border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center text-xs text-white/70 gap-4"
  >
    <div class="space-x-4">
      <span>© 2025 | wellext</span>
      <a href="https://www.wellext.de/legal/impressum" class="hover:underline">Impressum</a>
      <a href="https://www.wellext.de/legal/datenschutz" class="hover:underline">Datenschutz</a>
      <a href="https://www.wellext.de/legal/agb" class="hover:underline">AGB</a>
    </div>
    <div class="flex flex-row gap-5">
      <a href="https://www.instagram.com/wellext?igsh=MTM1c2V0b2VxYjR5Mg==" target="_blank" rel="noopener" class="text-green-400 hover:text-green-500 text-lg">
        <img src="/images/instagram.svg" alt="Instagram" class="h-9"/>
      </a>
      <a href="https://www.tiktok.com/@wellext?_t=ZN-8xTLf6dtKWw&_r=1" target="_blank" rel="noopener" class="text-green-400 hover:text-green-500 text-lg">
        <img src="/images/tick_tock.svg" alt="TickTock" class="h-9"/>
      </a>
      <a href="https://www.facebook.com/wellext/?locale=de_DE" target="_blank" rel="noopener" class="text-green-400 hover:text-green-500 text-lg">
        <img src="/images/facebook.svg" alt="Instagram" class="h-9"/>
      </a>
    </div>

  </div>
</footer>
